export default "__VITE_ASSET__CbxwbMKr__"